import { Injectable } from '@angular/core';
import { InstallationChecklistData } from '../../../../../../models/order/workflow/installation-checklist.model';
import { BaseWorkflowStateService } from '../base-workflow-state.service';

@Injectable({ providedIn: 'root' })
export class InstallationChecklistStateService extends BaseWorkflowStateService<InstallationChecklistData> {
    override stateKey: string = 'installationChecklist';
}
